
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, Injector, ChangeDetectorRef } from '@angular/core';

import { Store } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import * as fromBckpStore from '@apps/bckp/store';

import { InputCombobox2Component } from '../../input-combobox2/input-combobox2.component';

@Component({
    selector: 'aa-input-servers',
    templateUrl: '../../input-combobox2/input-combobox2.component.html',
    styleUrls: [
        '../../input.component.scss',
        '../../input-combobox/input-combobox.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputServersComponent,
            multi: true,
        }],
    standalone: false
})
export class InputServersComponent extends InputCombobox2Component
{
    constructor (
        injector: Injector,
        changeDetectorRef: ChangeDetectorRef,
        private store: Store<IAuroraState>
    )
    {
        super(injector, changeDetectorRef);

        this.store.dispatch(fromBckpStore.BckpOptionsStoreActions.BckpLoadServersRequested());
        this.items = this.store.select(fromBckpStore.getServersOptions);
    }
}
